import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import store from './store';
import LanguageWrapper from './components/Layout/LanguageWrapper';
import { RootErrorBoundary } from './components/RootErrorBoundary';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <RootErrorBoundary>
    <Provider store={store}>
      <LanguageWrapper>
        <App />
      </LanguageWrapper>
    </Provider>
  </RootErrorBoundary>
);

